<template>
  <div>
    <NavBar />
    <div class="container main-container">
        <div class="orderlist">
            <h3>Reclamo</h3>
            <div class="row order flex justify-content-center" v-for="line in lines" v-on:click="redactClaim($event, line)" v-bind:key="line.id">
                <div class="col-md-4 col-7 text-left flex align-items-center">
                    <div class="text-content align-items-center">
                        <strong>{{ line.qty }} {{ line.name }}</strong> <br />
                        <span class="text-nowrap faded">
                            <span class="text-nowrap faded cupon">{{ line.description }}</span>
                        <br/>
                        </span>
                        <span class="text-nowrap faded claim-text">{{ line.claim }}</span>
                        <br/>
                    </div>
                </div>
                <div class="col-md-4 col-5 flex align-items-center">
                    <div class="text-content align-items-center">
                        <span class="status-container">
                        <img
                            v-if="line.status == 'correct'"
                            src="../assets/icon-done.svg"
                            class="status-icon"
                        />
                        <img
                            v-if="line.status == 'claim'"
                            src="../assets/icon-cancelled.svg"
                            class="status-icon"
                        />
                        <br />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row icons justify-content-center fixed-bottom buttons-margin">
          <div class="text-xs-center">
              <button class="dg-btn dg-btn--cancel red" flat @click="goHome"><span class="text-white">Cancelar</span></button>
          </div>
          <div class="text-xs-center">
              <button class="dg-btn dg-btn--ok green" flat @click="doClaim" :disabled="!hasClaims"><span class="text-white">Reclamar</span></button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";

export default {
  name: "ClaimOrder",
  created() {
    if (!this.order){
        this.$router.push('home');
    }
    else {
      this.lines = [];
      for (var line in  this.order.detail){
        this.lines.push({...this.order.detail[line], claim:'', status: 'correct'})
      }
    }
  },
  components: {
    NavBar
  },
  props: {
    order: Object,
  },
  methods: {
    goHome: function() {
      this.$router.push('Home')
    },
    doClaim(){
      event.stopPropagation()
      var self = this;
      this.$dialog
        .confirm("Desea marcar este pedido con reclamo?", {
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(function(dialog) {
          console.log("se envia");
          console.log(self.lines);
          let url = self.$store.state.connection.url;
          console.log(url);
          console.log(self.order);
          let endpoint = `${url}orders/${self.order.id}/claim`;
          console.log(endpoint);
          self.$http
            .post(endpoint, {params: {claims: self.lines}})
            .then(response => {
              console.log("LLEGO LA RPTA");
              if (response.body.result) {
                self.$router.push('home');
              }
            })
            .catch(err => {});
        })
        .catch(function() {});
    },
    redactClaim: function ($event, line){
      this.$dialog
        .prompt({
          title: "Reclamo",
          body: "Lamentamos esta situación, por favor ingrese su queja",
          promptHelp: 'Queja',
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(dialog => {
          this.hasClaims = true;
          line.status = 'claim';
          line.claim = dialog.data;
        })
        .catch(()=>{
          console.log("Promp dismissed")
        });
    },
  },
  data: function() {
    return {
      lines: [],
      hasClaims: false,
    };
  }
};
</script>

<style scoped>
h3 {
  width: 100%;
  text-align: left;
  font-size: 25px;
}
.only-screen {
  margin-top: 10px;
}
.action {
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(94, 158, 203);
  margin-bottom: 3px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 7px;
  margin-right: 5px;
  color: #ffffff;
  min-width: 100px;
}
.sign {
  width: 15px;
  text-align: center;
  color: #ffffff;
  margin-left: 5px;
}
.remove {
  background-color: rgb(221, 47, 0);
}
.action span {
  margin-left: 3px;
}
.action img {
  max-height: 20px;
}
button {
  margin: 4px;
}
svg {
  margin-left: 5px;
  cursor: pointer;
}
.detail {
  margin-top: 4px;
}
.order {
  background-color: rgba(54, 127, 178, 0.1);
  display: flex;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 760px;
}
.faded {
  color: rgb(152, 145, 150);
}
.cupon {
  margin-right: 10px;
}
.flex {
  display: flex;
}
.text-content img {
  margin-top: -5px;
  margin-right: 5px;
}
.claim-text {
  color: #FF5C6E;
}
.buttons-margin {
  margin-bottom: 15px;
}
</style>
